import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { solicitudesApi } from "@/features/solicitudes/services/solicitudes.api";

/**
 * QueryOptions de la solicitud · compartido entre el loader de cada route
 * step (precarga vía `ensureQueryData`) y el componente (`useSuspenseQuery`).
 *
 * `staleTime: 30s` es deliberadamente corto · el estado de la solicitud
 * cambia con cada mutación (cargar CFDI, capturar datos, etc.) y queremos
 * refetch al volver del foco. Las mutaciones explícitas igual hacen
 * `setQueryData` para hidratar al instante.
 */
export const solicitudQueryOptions = (id: string) =>
  queryOptions({
    queryKey: qk.solicitud(id),
    queryFn: () => solicitudesApi.obtener(id),
    staleTime: 30_000,
  });

export function useSolicitud(id: string) {
  return useSuspenseQuery(solicitudQueryOptions(id));
}
